import React from 'react';
import StatCard from './StatCard';

interface DashboardStatsProps {
    stats: {
        leads: { value: string; change: number; base: string };
        closed: { value: string; change: number; base: string };
        value: { value: string; change: number; base: string };
        closedValue: { value: string; change: number; base: string };
        lost: { value: string; change: number; base: string };
        lostValue: { value: string; change: number; base: string };
    };
}

const DashboardStats: React.FC<DashboardStatsProps> = ({ stats }) => {
    return (
        <section aria-label="Indicadores do período" className="grid grid-cols-1 gap-s3 md:grid-cols-4 md:gap-s4">
            <StatCard
                title="Negociações"
                value={stats.leads.value}
                change={stats.leads.change}
                period="no período"
                baseValue={stats.leads.base}
                icon="handshake"
                accent="brand"
            />
            <StatCard
                title="Fechamentos"
                value={stats.closed.value}
                change={stats.closed.change}
                period="no período"
                baseValue={stats.closed.base}
                icon="package"
                accent="success"
            />
            <StatCard
                title="Valor em Negoc."
                value={stats.value.value}
                change={stats.value.change}
                period="no período"
                baseValue={stats.value.base}
                icon="dollar"
                accent="brand"
            />
            <StatCard
                title="Valor Fechado"
                value={stats.closedValue.value}
                change={stats.closedValue.change}
                period="no período"
                baseValue={stats.closedValue.base}
                icon="shopping-cart"
                accent="success"
            />
        </section>
    );
};

export default DashboardStats;
